import { getEndpoint } from "@api-routes/endpoint";

const ADDRESS_FINDER_MS_NAME = "address-finder";

export const getEircodeFinderRoute = (eircode: string) =>
    `${getEndpoint(ADDRESS_FINDER_MS_NAME)}address?eircode=${eircode}`;
